import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { SiteQuery as SiteQueryType, SiteQueryVariables } from "./__generated__/SiteQuery";

const SiteQuery = loader("./SiteQuery.gql");

type SiteQueryProviderType = (props: {
  children: (data: SiteQueryType) => ReactNode;
  variables: SiteQueryVariables;
}) => ReactElement;

export const SiteQueryProvider: SiteQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<SiteQueryType, SiteQueryVariables>(SiteQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
